const Loading = ()=> {
    return(
        <div className="loading flex-col-wrapper">
            <div className="loading-circle">
                
            </div>
        </div>
    );
};

export default Loading;